import { setLoggedOut } from '%app/js/common/redux/currentUser';

function reduxUnauthorizedInterceptor() {
    import('%paysera_admin/js/config/store').then((module) => {
        const { default: { dispatch } } = module;
        dispatch(setLoggedOut());
    });
}

export default reduxUnauthorizedInterceptor;
